//= require modules/series-modal
import {galleryModalTemplate} from '../templates';
import SeriesModal from './series-modal';

class GalleryModal {
  constructor($el) {
    new SeriesModal($el, galleryModalTemplate, {
      itemSelector: '.js-gallery__item',
      modalStyleModifierClasses: {
        container: 'modal-container--highlight background-off-white',
        closeIcon: 'icon-close-black',
      },
    });
  }
}

export default GalleryModal;
